module.exports = __webpack_public_path__ + "static/media/award_gray.2cdf81d4.svg";